// src/pages/Reports/Reports.js (main file)
import PropTypes from "prop-types"
import React, { useState } from "react"
import { Container, Row, Col } from "reactstrap"

// Components
import ReportSection from "./ReportSection" // filters
import ReportTable from "./ReportTable" // table with tabs, expansion, export

// Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// i18n
import { withTranslation } from "react-i18next"

const Reports = props => {
  // Filters state – yahan se control hoga (Dashboard jaisa hi)
  const [filters, setFilters] = useState({
    startDate: null,
    endDate: null,
    mobileNumbers: [], // array of strings
  })

  // Reset filters
  const handleReset = () => {
    setFilters({
      startDate: null,
      endDate: null,
      mobileNumbers: [],
    })
  }

  // Apply filters (ReportSection se call hoga)
  const handleApply = newFilters => {
    setFilters(newFilters)
  }

  // Page title
  document.title = "Reports | Your App Name"

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumb */}
          <Breadcrumbs
            title={props.t("Reports")}
            breadcrumbItem={props.t("All Reports")}
          />

          {/* Filters Section */}
          <Row className="mb-4">
            <Col xl="12">
              <ReportSection
                onApply={handleApply}
                onReset={handleReset}
                currentFilters={filters}
              />
            </Col>
          </Row>

          {/* Reports Table – filters pass kar do */}
          <Row className="mb-3">
            <Col xl="12">
              <ReportTable filters={filters} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Reports.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Reports)
